<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">门店管理</span>
      <div class="handler-area">
        <div class="add-story global_common_button_focus btn" v-if="false" @click="gopage('shopManagement/addShop')">
          <span>+添加门店</span>
        </div>
        <div
          class="setting btn global_common_button_goast"
          v-if="$store.getters.isChain == '1'"
          v-permission="'a'"
          @click="gopage('shopManagement/areaList')"
        >
          <span>大区设置</span>
        </div>
        <div v-if="modeSetShow()" class="setting btn global_common_button_goast" @click="changeMode(2)">
          <span>管理设置</span>
        </div>
        <div v-show="mode == 2" class="cancle global_common_button_goast btn" @click="cancle()">
          <span>取消设置</span>
        </div>
        <div v-show="mode == 2" class="submit global_common_button_main btn" @click="submit()">
          <span>保存设置</span>
        </div>
      </div>
    </h2>
    <div class="list-content">
      <div class="listSearchArea">
        <supervise-search
          v-if="superviseRole"
          @search="search"
          :searchData="searchData"
          class="pull-left is-print-hide"
          ref="searchBar"
        />
        <search-input v-else @search="search" :searchData="searchData" class="pull-left is-print-hide"></search-input>
      </div>
      <div class="totalData" v-if="superviseRole">共{{ prescriptionRes.totalCount }}条数据</div>
      <div class="toolbar" v-if="!superviseRole">
        <el-button @click="exportShopManagement">
          {{ `导出${prescriptionRes.totalCount > 0 ? `(${prescriptionRes.totalCount})` : ''}` }}
        </el-button>
      </div>
      <shop-table :List="prescriptionRes.data" @selectChange="selectChange" @DelItem="DelItem"></shop-table>
      <div class="footer" v-show="hasData()">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="pageSizes"
          :page-size.sync="pageSize"
          @size-change="handleSizeChange"
          layout="prev, pager, next, total, jumper,sizes"
          :total="prescriptionRes.totalCount"
          class="is-print-hide common-el-pagination"
        ></el-pagination>
        <div class="sureJump global_common_button_goast">确定</div>
        <div class="disabled_page global_common_text_hover" v-if="false" @click="godisabledShopList">
          点击查看 禁用门店 >
        </div>
      </div>
    </div>
    <!-- <direction></direction> -->
  </div>
</template>

<script>
import superviseSearch from '@/components/superviseSearch';
import searchInput from '@/components/shopManagement/searchBar';
import shopTable from '@/components/shopManagement/table.vue';
import { hasPermission } from '@/util';
// import direction from '@/components/global/direction';
import Constant from '@/lib/constant';
const baseRole = Constant.RoleList;
let isloadFinish = true; // 限制重复请求
export default {
  // name: 'shopManagement',
  computed: {
    mode() {
      return this.$store.getters.getShopManagementMode;
    },
    getchangeSetingList() {
      return this.$store.getters.getchangeSetingList;
    },
    superviseRole() {
      return this.$store.getters.superviseRole;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 刷新页面或者从详情页面进来默认不刷新数据
      ![null, 'showShop'].includes(from.name) && vm.resetData();
    });
  },
  data() {
    return {
      selectIds: '',
      currentPage: 1,
      prescriptionRes: {},
      searchData: {},
      pageSize: 12,
      pageSizes: [12, 24, 36, 48]
    };
  },
  components: {
    superviseSearch,
    searchInput,
    shopTable
    // direction
  },
  created() {
    let params = {
      pageNo: this.currentPage,
      pageSize: Constant.pageSize,
      status: ''
    };
    this.fetchList(params);
  },
  watch: {
    mode(val) {
      if (this.mode == 1) {
        this.refresh();
      }
    }
  },
  methods: {
    renderShowDis() {
      // 渲染禁用门店入口
      let per = [baseRole.a];
      if (hasPermission(per)) {
        return true;
      }
    },
    DelItem(id) {
      // 删除数据
      let { data } = this.prescriptionRes;
      try {
        this.prescriptionRes.data = data.filter(v => {
          if (v.id != id) {
            return v;
          }
        });
        this.$message({
          showClose: true,
          message: '操作成功',
          type: 'success'
        });
      } catch (error) {
        window.location.reload();
      }
    },
    godisabledShopList() {
      // 跳转到禁用列表
      this.$router.push('/shopManagement/disabledShop');
    },
    modeSetShow() {
      // 设置按钮
      let per = [baseRole.a, baseRole.c, baseRole.d];
      if (hasPermission(per) && this.mode == 1) {
        return true;
      }
    },
    refresh() {
      let params = {
        pageNo: this.currentPage,
        pageSize: Constant.pageSize,
        status: ''
      };
      this.fetchList(params);
    },
    resetData() {
      this.selectIds = '';
      this.currentPage = 1;
      this.prescriptionRes = {};
      this.searchData = {};
      let params = {
        pageNo: this.currentPage,
        pageSize: Constant.pageSize,
        status: ''
      };
      this.fetchList(params);
    },
    hasData() {
      // 翻页器
      let per = [baseRole.a, baseRole.c, baseRole.h, baseRole.i, baseRole.j];
      return hasPermission(per);
    },
    cancle() {
      // 取消变更
      this.$store.dispatch('shopManagement/CLEARDATALIST');
    },
    submit() {
      // 提交变更
      this.$store.dispatch('shopManagement/SUBMITSETTINGLIST');
    },
    addStoryShow() {
      // 渲染添加门店逻辑

      let per = [baseRole.a];
      let res = hasPermission(per);
      if (this.mode == 1 && res) {
        // 负责人并且当前是默认模式
        return true;
      }
    },
    changeMode(mode) {
      // 改变页面模式
      this.$store.commit('shopManagement/SET_MODE', mode);
    },
    gopage(p) {
      // 页面调转
      this.$router.push(p);
    },
    initData() {
      this.currentPage = 1;
      this.prescriptionRes = {};
      this.searchData = {
        storeName: '',
        prescriptionTotalStatus: ''
      };
    },
    search(data) {
      this.currentPage = 1;
      this.searchParam = data;
      const { date, ...rest } = this.searchParam;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...rest
      };
      let self = this;
      Util.submitOnce(function () {
        self.fetchList(params);
      });
    },
    handleCurrentChange(val) {
      let params = {
        pageNo: val,
        pageSize: this.pageSize,
        ...this.searchParam
      };
      this.fetchList(params);
    },
    handleSizeChange(val) {
      let params = {
        pageNo: this.currentPage,
        pageSize: val,
        ...this.searchParam
      };
      this.fetchList(params);
    },
    fetchList(params) {
      if (!isloadFinish) return;
      isloadFinish = false;
      // 监管账号只显示已审核的药店
      this.$store.getters.superviseRole && (params.status = 1);
      Fetch.get_store_page({ ...params, isDelete: 0 }).then(
        res => {
          // 调试禁用状态使用
          /* res.data = res.data.map(v => {
            v.disableStatus = 1;
            return v;
          }); */
          isloadFinish = true;
          this.prescriptionRes = res;
        },
        () => {
          isloadFinish = true;
          this.prescriptionRes = {};
        }
      );
    },
    selectChange(ids) {
      this.selectIds = ids;
    },
    exportShopManagement() {
      const { status, storeName, remotePharmacistStatus, storePharmacistStatus, faceStatus, areaId } =
        this.searchParam || {};
      if (this.prescriptionRes.totalCount > 0) {
        if (this.prescriptionRes.totalCount > 9999) {
          this.$alert('导出数据量过大会导致导出失败，建议调整导出范围，最多能导出9999条', '数据导出失败', {
            customClass: 'hint',
            center: true,
            confirmButtonText: '重新选择导出范围'
          });
        } else {
          this.$store.dispatch('download/exportFile', {
            exportType: 'export_store_async',
            status,
            storeName,
            remotePharmacistStatus,
            storePharmacistStatus,
            faceStatus,
            areaId
          });
        }
      } else {
        this.$message.error('导出数量不能为空');
      }
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
.title-area {
  overflow: hidden;
  padding-bottom: 10px;

  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    overflow: hidden;
    .setting {
    }
    .add-story {
      // background: #ebb436;
      // &:hover {
      //   background: rgba(255, 195, 59, 1);
      // }
      // span {
      //   color: #fff;
      // }
    }
    .btn {
      width: 132px;
      height: 40px;
      float: right;
      line-height: 40px;
      text-align: center;
      margin-right: 16px;
      border-radius: 4px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
  }
  .cancle {
  }
  .submit {
  }
}
.totalData {
  color: #333;
  font-size: 14px;
  line-height: 30px;
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  min-height: 600px;
  .listSearchArea {
    /*padding-bottom: 20px;*/
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .select_from_store_name {
      float: left;
    }
  }

  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
  }
}
.footer {
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
  .sureJump {
    // float: left;
    width: 80px;
    height: 32px;
    // color: #1E8DFF;
    // background: #ffffff;
    // border: 1px solid #1E8DFF;
    border-radius: 3px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
  }
  .disabled_page {
    position: absolute;
    display: flex;
    align-items: center;
    right: 20px;
    top: 30px;
    cursor: pointer;
  }
}
</style>
